import classNames from 'classnames';
import { Icon, toIconsEnum } from 'components/Icons';
import { AnchorLink } from 'components/anchorLink';
import { RootState } from 'lib/centralStore';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import styles from './VirtualTopNavigationItem.module.scss';

export type VirtualTopNavigationItemProps = {
  idDisciplina: string;
  descrizione: string;
  slug: string;
  isActive?: boolean;
};

export const VirtualTopNavigationItem = ({
  idDisciplina,
  descrizione,
  slug,
  isActive,
}: VirtualTopNavigationItemProps) => {
  const { asPath } = useRouter();
  const { isLoading } = useSelector((state: RootState) => state.location);
  const disciplinaIcon = `DISCIPLINA_${idDisciplina}`;

  return (
    <li
      className={classNames(styles.container, styles.containerVirtual, {
        [styles.disabled]: isLoading,
        [styles.activeItem]: isActive || asPath === `/${slug}`,
      })}
      suppressHydrationWarning
    >
      <AnchorLink href={`/${slug}`} className={classNames(styles.link)} rel={isActive ? undefined : 'nofollow'}>
        <Icon iconId={toIconsEnum(disciplinaIcon)} className={styles.icon} color={'var(--color-on-bg-secondary)'} />
        <span className={styles.description}>{descrizione}</span>
      </AnchorLink>
    </li>
  );
};
